module.exports = __webpack_public_path__ + "static/img/product_lora.bf4e295.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_lora.jpg
// module id = J8FF
// module chunks = 0